<template>
  <div>
    <div v-if="period.isOngoing()" style="display: inline">
      <i18n-t keypath="features.long_term.explainer.ongoing_irradiance">
        <template #irradiance_percentage>
          <strong>{{ period.getRadiationReceived().toString() }}</strong>
        </template>
      </i18n-t>

      <div v-if="period.isTooEarly()" style="display: inline">
        <i18n-t keypath="features.long_term.explainer.ongoing_early">
          <template #term>
            <strong>
              {{ $t('features.long_term.explainer.too_early') }}
            </strong>
          </template>
        </i18n-t>
      </div>

      <!-- adds a space between lines -->
      {{}}

      <i18n-t
        keypath="features.long_term.explainer.ongoing_delivered_till_now"
      >
        <template #delivered>
          <strong>{{ period.getDeliveredTillNow().toString() }}</strong>
        </template>

        <template #including_gap_fills>
          <span v-if="period.getActiveGapFills().length > 0">
            {{ $t('features.long_term.gap_fills.gap_fill_including') }}
          </span>
        </template>
      </i18n-t>

      <div v-if="period.getMissingEnergy().gt(0)" style="display: inline">
        {{}}

        <i18n-t keypath="features.long_term.explainer.ongoing_behind">
          <template #missing>
            <strong>{{ period.getMissingEnergy().toString() }}</strong>
          </template>

          <template #needed>
            <strong>{{ period.getNeededPerformancePctToCompensate() }}</strong>
          </template>
        </i18n-t>
      </div>

      <div v-else style="display: inline">
        {{}}

        <i18n-t keypath="features.long_term.explainer.ongoing_ahead">
          <template #term>
            <strong>{{ $t('features.long_term.explainer.ahead') }}</strong>
          </template>

          <template #ahead>
            <strong>{{ period.getCurrentRealizedPct().toString() }}</strong>
          </template>
        </i18n-t>
      </div>
    </div>

    <!-- ended-->
    <div v-else>
      {{}}

      <i18n-t keypath="features.long_term.explainer.ended_total">
        <template #delivered>
          <strong>{{ period.getDeliveredTillNow().toString() }}</strong>
        </template>

        <template #promised>
          <strong>{{ period.getPromisedTillNow().toString() }}</strong>
        </template>
      </i18n-t>

      <div
        v-if="
          period.getCurrentRealizedPct().asPercentage() > -0.5 &&
          period.getCurrentRealizedPct().asPercentage() < 0.5
        "
      >
        <i18n-t keypath="features.long_term.explainer.ended_total">
          <template #result>
            <strong>
              {{ $t('features.long_term.explainer.within_05') }}
            </strong>
          </template>
        </i18n-t>
      </div>

      <div v-else-if="period.getMissingEnergy().gt(0)">
        <i18n-t keypath="features.long_term.explainer.ended_result">
          <template #result>
            <strong>
              {{ period.getCurrentRealizedPct().times(-1).toString() }}
              {{ $t('features.long_term.explainer.less') }}
            </strong>
          </template>
        </i18n-t>
      </div>

      <div v-else>
        <i18n-t keypath="features.long_term.explainer.ended_result">
          <template #result>
            <strong>
              <strong>{{ period.getCurrentRealizedPct().toString() }} </strong>
              {{ $t('features.long_term.explainer.more') }}
            </strong>
          </template>
        </i18n-t>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import YieldPromiseStatus from '@/domain/model/business/YieldPromiseStatus.ts';

export default {
  name: 'LongTermPeriodExplainer',
  props: {
    period: { type: YieldPromiseStatus, required: true },
  },
};
</script>

<style scoped></style>
